import { LogglyTracker } from 'loggly-jslogger';
import { getActiveSlideId, getOrCreatePresentationId } from '../db/ppt';
import { getActivityType } from '../db/shared';
import { serializeError } from './objects';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const tracker = new LogglyTracker();

const LOGGLY_TAG = 'acadly-ppt-addin-production';

tracker.push({
  logglyKey: process.env.REACT_APP_LOGGLY_KEY,
  sendConsoleErrors: true,
  tag: LOGGLY_TAG,
});

function logFn(level: LogLevel, namespace: string) {
  if (process.env.REACT_APP_ENV === 'production') {
    if (level === 'debug') {
      return () => {};
    }

    return async (...args: any[]) => {
      const { version: officeVersion } = Office.context.diagnostics;
      const userAgent = window.navigator.userAgent;

      const { presentationId, isNewPresentation } = await getOrCreatePresentationId();
      const slideId = await getActiveSlideId();
      const slideType = getActivityType(presentationId, slideId ?? '');

      const errors = args.map(serializeError);

      tracker.push({
        officeVersion,
        userAgent,
        presentationId: isNewPresentation ? undefined : presentationId,
        slideId,
        slideType,
        args: errors,
        level,
        tag: LOGGLY_TAG,
        version: process.env.REACT_APP_VERSION,
      });
    };
  }

  if (process.env.NODE_ENV !== 'test') {
    return console[level].bind(window, `[${namespace}]`);
  }

  return () => {};
}

const Logger = {
  debug: logFn('debug', 'acadly'),
  info: logFn('info', 'acadly'),
  warn: logFn('warn', 'acadly'),
  error: logFn('error', 'acadly'),
  create(scope: string) {
    return {
      debug: logFn('debug', scope),
      info: logFn('info', scope),
      warn: logFn('warn', scope),
      error: logFn('error', scope),
    };
  },
};

export default Logger;
